export enum PhoneStatus {
  ACTIVE = 1, // user has notifications on
  INACTIVE = 2, // if user has stopped through brkfst, or not turned on notifications
  BLOCKED = 3, // if user has stopped via SMS keyword
}
